import { render, staticRenderFns } from "./notificationsSettings.vue?vue&type=template&id=62d3d959&scoped=true"
import script from "./notificationsSettings.vue?vue&type=script&lang=js"
export * from "./notificationsSettings.vue?vue&type=script&lang=js"
import style0 from "./notificationsSettings.vue?vue&type=style&index=0&id=62d3d959&lang=scss&scoped=true"
import style1 from "./notificationsSettings.vue?vue&type=style&index=1&id=62d3d959&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d3d959",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62d3d959')) {
      api.createRecord('62d3d959', component.options)
    } else {
      api.reload('62d3d959', component.options)
    }
    module.hot.accept("./notificationsSettings.vue?vue&type=template&id=62d3d959&scoped=true", function () {
      api.rerender('62d3d959', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/notificationsSettings.vue"
export default component.exports